import * as RemoveIconThin from "@assets/images/svg/remove-icon-thin.svg";
import * as EyeIcon from "@assets/images/svg/eye.svg";
import * as EyeSlashIcon from "@assets/images/svg/eye-slash.svg";
import * as SortIcon from "@assets/images/svg/sort.svg";
import * as SpriteIcon from "@assets/images/svg/sprite-icon.svg";
import * as ArrowUpIcon from "@assets/images/svg/arrow-trg-up.svg";
import * as ArrowDownIcon from "@assets/images/svg/arrow-trg-down.svg";
import * as ArrowThinLeftIcon from "@assets/images/svg/arrow-thin-left.svg";
import * as ArrowThinRightIcon from "@assets/images/svg/arrow-thin-right.svg";
import * as MessageIcon from "@assets/images/svg/message-icon.svg";
import * as SecurityIcon from "@assets/images/svg/security-icon.svg";
import * as PlusIcon from "@assets/images/svg/plus.svg";
import * as Plus2Icon from "@assets/images/svg/plus2.svg";
import * as SearchIcon from "@assets/images/svg/search.svg";
import * as UploadIcon from "@assets/images/svg/upload.svg";
import * as UploadCloudIcon from "@assets/images/svg/upload-cloud.svg";
import * as LinkIcon from "@assets/images/svg/link.svg";
import * as CopyIcon from "@assets/images/svg/copy.svg";
import * as LogoText from "@assets/images/logo-text.png";
import * as CrownIcon from "@assets/images/svg/crown.svg";
import * as ArrowRight from "@assets/images/svg/arrow-right.svg";
import * as NextIcon from "@assets/images/svg/right-arrow-icon.svg";
import * as PrevIcon from "@assets/images/svg/left-arrow-icon.svg";
import * as ArrowDown from "@assets/images/svg/arrow-down.svg";
import * as Text from "@assets/images/svg/text.svg";
import * as HeadPhone from "@assets/images/svg/head-phone.svg";
import * as Notification from "@assets/images/svg/notification-bing.svg";
import * as SearchNormalIcon from "@assets/images/svg/search-nornal.svg";
import * as AltArrowDownIcon from "@assets/images/svg/alt-arrow-down.svg";
import * as NoData from "@assets/images/svg/no-data.svg";
import * as CloseCircleIcon from "@assets/images/svg/close-circle.svg";
import * as CheckIcon from "@assets/images/svg/check.svg";
import * as Line from "@assets/images/svg/line.svg";
import * as Momo from "@assets/images/svg/momo.svg";
import * as ZaloPay from "@assets/images/svg/zaloPay.svg";
import * as ResultNotFound from "@assets/images/svg/result-not-found.svg";
import * as CopyPayment from "@assets/images/svg/copyPayment.svg";
import * as ArrowRightBlack from "@assets/images/svg/arrow-right-black.svg";
import * as BackwardIcon from "@assets/images/svg/backward.svg";
import * as PauseIcon from "@assets/images/svg/pause.svg";
import * as PlayIcon from "@assets/images/svg/play.svg";
import * as ForwardIcon from "@assets/images/svg/forward.svg";
import * as VolumnIcon from "@assets/images/svg/volumn.svg";
import * as VolumnCrossIcon from "@assets/images/svg/volumn-cross.svg";
import * as CloseIcon from "@assets/images/svg/close.svg";
import * as PlayPreviewIcon from "@assets/images/svg/play-preview.svg";
import * as ArrowLeft from "@assets/images/svg/arrow-left.svg";
import * as PenIcon from "@assets/images/svg/pen.svg";
import * as Success from "@assets/images/svg/success.svg";

export const Images = {
  RemoveIconThin,
  EyeIcon,
  EyeSlashIcon,
  SortIcon,
  SpriteIcon,
  ArrowUpIcon,
  ArrowDownIcon,
  ArrowThinLeftIcon,
  ArrowThinRightIcon,
  MessageIcon,
  SecurityIcon,
  PlusIcon,
  Plus2Icon,
  SearchIcon,
  UploadIcon,
  UploadCloudIcon,
  LinkIcon,
  CopyIcon,
  LogoText,
  CrownIcon,
  ArrowRight,
  NextIcon,
  PrevIcon,
  ArrowDown,
  Text,
  HeadPhone,
  Notification,
  SearchNormalIcon,
  AltArrowDownIcon,
  NoData,
  CloseCircleIcon,
  CheckIcon,
  Line,
  Momo,
  ZaloPay,
  ResultNotFound,
  CopyPayment,
  ArrowRightBlack,
  BackwardIcon,
  PauseIcon,
  PlayIcon,
  ForwardIcon,
  VolumnIcon,
  VolumnCrossIcon,
  CloseIcon,
  PlayPreviewIcon,
  ArrowLeft,
  PenIcon,
  Success,
};
